import "./style.less"

const Spinner = () => {
  return (
    <div className="loader-2 center">
      <span />
    </div>
  )
}

export default Spinner
